//お問い合わせ
$(function () {
  //チェックボックス その他が選ばれた時、その他のテキストエリアを活性化する。
  $(".js-check-disabled-trigger").on("change", function () {
    var trigger = $(this);
    var ancestor = $(".js-check-disabled");
    var textarea = $(".js-check-disabled-textarea");
    var input;
    if (trigger.data("disabled")) {
      input = $(this).closest(ancestor).find(textarea);
    } else {
      input = $(this).closest(ancestor).find(textarea);
    }

    if (trigger.prop("checked") == true && input.prop("disabled") == true) {
      input.prop("disabled", false);
    } else {
      input.prop("disabled", true);
    }
  });

  //ラジオボタンでenable_flagにtrueを入れた時、テキストエリアを非活性にする
  $(".js-radio-disabled-textarea-trigger").on("change", function () {
    var ancestor = $(".js-radio-disabled");
    var inputsToDesiredArea = $(".js-radio-disabled-textarea");
    var input;
    input = $(this).closest(ancestor).find(inputsToDesiredArea);

    console.log(input);
    if ($(this).data("enable_flag")) {
      input.prop("disabled", false);
    } else {
      input.prop("disabled", true);
    }
  });

  //ラジオボタン　法人の場合、法人の価格表、それ以外の場合個人・未開業の価格表を
  //表示する
  $(".js-disabled-trigger").on("change", function () {
    var disabledType = $(this).data("disabled");
    var isChecked = $(this).prop("checked");
    var toDisabled = $(".js-disabled-input");
    // .js-closing-month-rowが存在しないフォームでは以下は何も選択されず、無視される
    var closingMonthRow = $(".js-closing-month-row");

    if (!isChecked) return;

    if (disabledType == "corporation") {
      $(".js-budget-corporation").show();
      $(".js-budget-other").hide();
      toDisabled.parents(".input-select-front").removeClass("is-disabled");
      toDisabled.prop("disabled", false);
      $("#president_name").show();
      closingMonthRow.show();
    } else if (disabledType == "personal") {
      $(".js-budget-other").show();
      $(".js-budget-corporation").hide();
      toDisabled.parents(".input-select-front").addClass("is-disabled");
      toDisabled.prop("disabled", true);
      $("#president_name").hide();
      closingMonthRow.hide();
      closingMonthRow.find("select").val("");
    } else {
      $(".js-budget-other").show();
      $(".js-budget-corporation").show();
      toDisabled.parents(".input-select-front").addClass("is-disabled");
      toDisabled.prop("disabled", true);
      $("#president_name").hide();
      closingMonthRow.hide();
      closingMonthRow.find("select").val("");
    }

    updateBudgetTableImages();
  });

  $(".js-annual-sales-type-trigger").on("change", function () {
    updateBudgetTableImages();
    updateAnnualSalesSelectedText();
  });

  // 相談内容の詳細の、テンプレートテキスト挿入処理
  const templates = {
    seturitu:
      "起業・会社設立について相談させてください。設立の手続きや必要な準備、設立後の会計処理について伺いたいです。",
    houzinka:
      "個人事業主から法人化を検討しています。手続きや必要な準備、法人化後の会計処理について相談させてください。お見積りについても伺いたいです。",
    kakutei: "個人事業主の確定申告について相談させてください。 お見積りや必要な準備について伺いたいです。",
    kessan: "法人決算の依頼ができる税理士を探しています。 依頼に必要な書類や、今後の進め方について教えてください。"
  };
  $(".js-template-insert-trigger").on("click", function (e) {
    e.preventDefault();
    const key = $(this).data("template");
    const text = templates[key];
    if (!text) return;

    const $textarea = $(".js-input-template");
    if ($textarea.length === 0) return;

    // 内容を上書き
    $textarea.val(text).focus();

    // React/Vue等が絡む場合や、監視してる処理がある場合に備えて
    $textarea.trigger("input");
  });

  // バリデーションエラー等でその他のdisabledをチェックする
  // その他初期設定
  // 相談内容
  var messageOther = $(".js-check-disabled-trigger.message");
  var messageOtherTextarea = $(".js-check-disabled-textarea.message");
  if (messageOther.prop("checked") == true && messageOtherTextarea.prop("disabled") == true) {
    messageOtherTextarea.prop("disabled", false);
  }

  //　紹介を希望しない事務所
  var relatedOfficeFlag = $(".js-radio-disabled-textarea-trigger.office[data-enable_flag=true]");
  var relatedOfficeTextarea = $(".js-radio-disabled-textarea.office");
  if (relatedOfficeFlag.prop("checked")) {
    relatedOfficeTextarea.prop("disabled", false);
  }

  //　希望するエリア
  var areaOther = $(".js-check-disabled-trigger.area");
  var areaOtherTextarea = $(".js-check-disabled-textarea.area");

  if (areaOther.prop("checked") == true && areaOtherTextarea.prop("disabled") == true) {
    areaOtherTextarea.prop("disabled", false);
  }

  // 会計ソフト
  var softwareOther = $(".js-check-disabled-trigger.software");
  var softwareOtherTextarea = $(".js-check-disabled-textarea.software");

  if (softwareOther.prop("checked") == true && softwareOtherTextarea.prop("disabled") == true) {
    softwareOtherTextarea.prop("disabled", false);
  }
  // 事業形態「未開業」
  var business = $(".js-disabled-trigger.business[data-disabled=not_open]");
  var businessInputs = $(".js-disabled-input.business");
  if (business.prop("checked") == true) {
    businessInputs.each(function (i, e) {
      $(e).prop("disabled", true);
      $(e).parents(".input-select-front").addClass("is-disabled");
    });
    $(".js-budget-other").show();
    $(".js-budget-corporation").show();
    $("#president_name").hide();
    // .js-closing-month-rowが存在しないフォームでは何も選択されず、無視される
    $(".js-closing-month-row").hide();
    $(".js-closing-month-row select").val("");
  }

  // 事業形態「個人事業主」
  var personalBusiness = $(".js-disabled-trigger.business[data-disabled=personal]");
  var personalInputs = $(".js-disabled-input.business");
  if (personalBusiness.prop("checked") == true) {
    personalInputs.each(function (i, e) {
      $(e).prop("disabled", true);
      $(e).parents(".input-select-front").addClass("is-disabled");
    });
    $(".js-budget-other").show();
    $(".js-budget-corporation").hide();
    $("#president_name").hide();
    $(".js-closing-month-row").hide();
    $(".js-closing-month-row select").val("");
  }

  // 事業形態「法人」
  var personalBusiness = $(".js-disabled-trigger.business[data-disabled=corporation]");
  var personalInputs = $(".js-disabled-input.business");
  if (personalBusiness.prop("checked") == true) {
    $(".js-budget-corporation").show();
    $(".js-budget-other").hide();
    $(".js-closing-month-row").show();
  }

  $(".js-inquiry-offices-search").on("click", function () {
    var trigger = $(this);
    var url = trigger.data("url");
    // formを作成してmethod: patchでsubmit
    var form = $("<form></form>", {
      action: url,
      method: "post"
    });
    form.append($("<input />", { type: "hidden", name: "_method", value: "patch" }));

    form.append(
      $("<input />", {
        type: "hidden",
        name: "authenticity_token",
        value: $("meta[name='csrf-token']").attr("content")
      })
    );
    form.appendTo("body").submit();
  });

  //　表エリア初期表示
  updateBudgetTableImages();
  updateAnnualSalesSelectedText();

  function annualSalesToImageKey(salesKey) {
    if (!salesKey) return null;

    // 1000以下は共通
    if (["up_to_300", "from_300_to_500", "from_500_to_1000"].includes(salesKey)) return "1000";

    if (salesKey === "from_1000_to_3000") return "over1000";
    if (salesKey === "from_3000_to_5000") return "over3000";
    if (salesKey === "from_5000_to_10000") return "over5000";

    // 10000以上は共通（※あなたの画像が over10000 でまとまっている前提）
    if (["from_10000_to_50000", "from_50000_to_100000", "over_100000"].includes(salesKey)) return "over10000";

    return null;
  }

  function updateBudgetTableImages() {
    const salesKey = $(".js-annual-sales-type-trigger").val(); // "up_to_300" 等
    const imageKey = annualSalesToImageKey(salesKey);
    if (!imageKey) {
      $(".js-hide-when-annual-sales-empty").hide();
      $(".js-hide-when-annual-sales-present").show();
      $(".js-disable-when-annual-sales-empty").prop("disabled", true);
      $(".js-budget-check").toggleClass("is-disabled", true);
      return;
    } else {
      $(".js-hide-when-annual-sales-empty").show();
      $(".js-hide-when-annual-sales-present").hide();
      $(".js-disable-when-annual-sales-empty").prop("disabled", false);
      $(".js-budget-check").toggleClass("is-disabled", false);
    }
    const dict = window.BUDGET_TABLE_IMAGES;
    const hojinPC = dict && dict.hojin && dict.hojin.pc && dict.hojin.pc[imageKey];
    const hojinSP = dict && dict.hojin && dict.hojin.sp && dict.hojin.sp[imageKey];
    const kojinPC = dict && dict.kojin && dict.kojin.pc && dict.kojin.pc[imageKey];
    const kojinSP = dict && dict.kojin && dict.kojin.sp && dict.kojin.sp[imageKey];
    if (!hojinPC || !hojinSP) return;
    if (!kojinPC || !kojinSP) return;

    if (hojinPC && hojinSP) {
      $(".js-budget-img--hojin-pc").attr("src", hojinPC);
      $(".js-budget-img--hojin-sp").attr("src", hojinSP);
    }
    if (hojinPC && hojinSP) {
      $(".js-budget-img--kojin-pc").attr("src", kojinPC);
      $(".js-budget-img--kojin-sp").attr("src", kojinSP);
    }
  }

  function updateAnnualSalesSelectedText() {
    const salesKey = $(".js-annual-sales-type-trigger").val(); // ←あなたのselectのclassに合わせて
    const text = annualSalesLabelText(salesKey);

    // 未選択のときの扱い（例：全体を消す）
    // 「年商：◯◯の場合」の塊を消したいなら、親要素にクラスを付けてそれをhideするのが一番楽
    if (!text) {
      $(".js-annual-sales-selected").text("");
      return;
    }

    $(".js-annual-sales-selected").text(text);
  }

  function annualSalesLabelText(salesKey) {
    const map = {
      up_to_300: "1000万円未満",
      from_300_to_500: "1000万円未満",
      from_500_to_1000: "1000万円未満",
      from_1000_to_3000: "1000万円〜",
      from_3000_to_5000: "3000万円〜",
      from_5000_to_10000: "5000万円〜",
      from_10000_to_50000: "1億〜",
      from_50000_to_100000: "1億〜",
      over_100000: "1億〜"
    };
    return map[salesKey] || "";
  }
});
